module.exports = "<img [className]='imgClass' src=\"{{ avatar }}\" default-src />\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-avatar/my-avatar.component.html
// module id = ./src/app/my-avatar/my-avatar.component.html
// module chunks = main